import React, { forwardRef } from 'react';
import cn from 'classnames';
import createPaginationArray from './functions/createPaginationArray';

export interface PageIndicatorProps {
    pages: number;
    numbered?: boolean;
    disabled?: boolean;
    selected?: number;
    onPageSelect?: (event: React.MouseEvent<HTMLDivElement>) => void;
    className?: string;
}

export const PageIndicator = forwardRef<HTMLDivElement, PageIndicatorProps>(
    (props, ref) => {
        const {
            pages,
            numbered,
            disabled,
            selected = 1,
            onPageSelect,
            className,
        } = props;

        const classes = cn(
            'a-page-indicator',
            {
                '-disabled': disabled,
                'a-page-indicator--numbered': numbered,
            },
            className,
        );

        let pageArray = [];
        if (numbered) {
            pageArray = createPaginationArray(selected, pages);
        } else {
            for (let i = 1; i < pages + 1; i += 1) {
                pageArray.push(i);
            }
        }

        return (
            <div
                ref={ref}
                className={classes}
                data-start-index={selected}
                data-max-length={pages}
                aria-label="Page indicator"
            >
                {numbered && <div className="a-page-indicator__caret -left" />}
                <div className="a-page-indicator__container">
                    {pageArray.map((page, index) => {
                        const indicatorClass = cn(
                            'a-page-indicator__indicator',
                            { '-selected': selected === page },
                        );
                        return (
                            <div
                                className={indicatorClass}
                                key={index}
                                data-index={
                                    typeof page === 'number' ? page : null
                                }
                                onClick={onPageSelect}
                            >
                                {numbered && <span>{page}</span>}
                            </div>
                        );
                    })}
                </div>
                {numbered && <div className="a-page-indicator__caret -right" />}
            </div>
        );
    },
);
PageIndicator.displayName = 'PageIndicator';
